const defaultState = { isWebvitalsTriggered: false };

const WebvitalsReducer = function WebvitalsReducer(state = defaultState, action) {
    switch (action.type) {
        case 'TRIGGER_WEBVITALS':
            return { ...state, isWebvitalsTriggered: true };
        default:
            return state;
    }
};

WebvitalsReducer.reducerName = 'webvitals';

export default WebvitalsReducer;
